// removed by extract-text-webpack-plugin
module.exports = {"dateRangePicker":"DateRangePresetsPanel-dateRangePicker","ranges":"DateRangePresetsPanel-ranges"};